export default __webpack_public_path__ + "static/strategic_iot-55a1a94fdfe87c3acfc006ab3f5f886b.webp";